var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal retirement-calculator-modal",class:{ active: _vm.modal }},[_c('div',{staticClass:"modal-card"},[_c('RetirementCalculator',{attrs:{"in_modal":true},on:{"cancel":function($event){return _vm.cancel()},"close_modal":function($event){return _vm.close_modal($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }